import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Styles from './EmailTemplates.module.css';
import Page from 'Common/Layout/Page';
import ActionButton from 'Common/Buttons/ActionButton';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ConfirmModal from '../../../Common/Components/ConfirmModal/ConfirmModal';
import PropTypes from 'prop-types';
import groupingObj from 'Common/Constants/GroupingObj';
import Typography from '@material-ui/core/Typography';

const View = ({
    handleGroupChange,
    selectedGroupId,
    selectedGroupName,
    handleChange,
	templates,
	submit,
	bodyChanged,
	selectedTemplate,
	editedBody,
	uploadResult,
	showHtml,
	selectedTitle,
	rteToHtml,
	isSaveDisabled,
	isPreviewDisabled,
	handleOk,
	showModal,
	redirectToHome
}) => {
	const parseText = () => {
		if (editedBody === '') return '';
		let result = rteToHtml();
		return result;
	};
	let groupingKeys = Object.keys(groupingObj);

	return (
        <Page title="Email Templates">
			<div className="container">
				<FormControl className={Styles.formControl}>
                    <InputLabel id="selectGrouping-label">Group</InputLabel>
                    <Select labelId="selectGrouping-label" id="selectGrouping" value={selectedGroupId} label="Choose group" onChange={handleGroupChange}>
						{groupingKeys.map(grouping => (
							<MenuItem key={grouping} value={groupingObj[grouping]}>
								{grouping}
							</MenuItem>
						))}
					</Select>
                </FormControl> 
			</div>
			<div className="container">
				<FormControl className={Styles.formControl}>
                    <InputLabel id="selectTemplate-label">Template</InputLabel>
                    <Select labelId="selectTemplate-label" id="selectTemplate" value={selectedTemplate} label="Choose template" onChange={handleChange}>
						{templates.map(template => (
							<MenuItem key={template.nodeId} value={template.nodeId}>
								{template.name}
							</MenuItem>
						))}
					</Select>
                </FormControl>
            </div>
            <div className="container">
                <br />
				<Typography variant="h3">{selectedGroupName} &nbsp;&nbsp;&nbsp; {selectedTitle}</Typography>
            </div>
            <div className={Styles.result}>
                <SuccessFailure {...uploadResult} successMessage="Change Submitted Successfully" failMessage="Failed to Submit Change" />
            </div>
			<div className="container">
				<ActionButton text="Save" onClick={submit} isDisabled={isSaveDisabled} />
				<ActionButton text="HTML" onClick={showHtml} isDisabled={isPreviewDisabled} />
				<ActionButton text="Main Menu" className="primary" onClick={redirectToHome} />
				<Editor
					editorState={editedBody}
					toolbarClassName="toolbarClassName"
					wrapperClassName="demo-wrapper"
					editorClassName={Styles.rte}
					onEditorStateChange={bodyChanged}
					toolbar={{
						options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'colorPicker', 'history'],
						inline: { inDropdown: true },
						textAlign: { inDropdown: true },
						link: { inDropdown: true }
					}}
				/>
			</div>
			<ConfirmModal
				isOpen={showModal}
				showWithdraw={false}
				showProceed={true}
				proceedButton={'Ok'}
				onProceed={handleOk}
				heading={selectedTitle}
				message={parseText()}
            />
            <div></div>
		</Page>
	);
};

View.propTypes = {
	handleChange: PropTypes.func.isRequired,
	templates: PropTypes.array.isRequired,
	submit: PropTypes.func.isRequired,
	bodyChanged: PropTypes.func.isRequired,
	selectedTemplate: PropTypes.any.isRequired,
    selectedGroupId: PropTypes.any.isRequired,
	editedBody: PropTypes.any.isRequired,
	uploadResult: PropTypes.object.isRequired,
	showHtml: PropTypes.func.isRequired,
	selectedTitle: PropTypes.string.isRequired,
	rteToHtml: PropTypes.func.isRequired,
	isSaveDisabled: PropTypes.bool.isRequired,
	isPreviewDisabled: PropTypes.bool.isRequired,
	handleOk: PropTypes.func.isRequired,
	showModal: PropTypes.bool.isRequired,
	redirectToHome: PropTypes.func.isRequired
};
export default View;
